import { ChangeDetectorRef, Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { TimesheetService } from "src/app/services/timesheet.service";
import { Config } from "src/app/utility/config";
import Swal from "sweetalert2";
import * as moment from "moment";
import { Toaster } from "ngx-toast-notifications";
import { Lookuphead1Service } from "../../lookuphead/lookuphead1.service";
import { LookupsService } from "src/app/services/lookups.service";
import { ToastrService } from "ngx-toastr";
import { EmployeeService } from "../../hrm/employee/employee.service";
import { TimeSheetProjectService } from "src/app/services/time-sheet-project.service";

@Component({
  selector: "app-timesheet-dashboard",
  templateUrl: "./timesheet-dashboard.component.html",
  styleUrls: ["./timesheet-dashboard.component.scss"],
})
export class TimesheetDashboardComponent {
  // this is for selct serach input
  exportForm: FormGroup;
  projects: string[] = [];
  projectData: { [key: string]: { [key: string]: number } } = {};
  entryForm: FormGroup;
  entries: any[] = [];
  ModalOpen: boolean = false;
  ModalOpen2: boolean = false;
  timeSheets: any[];
  userObj: any;
  userData: any;
  user: any;
  user_Id: any;
  userType: any;
  employee_Id: any;
  timeSheetdata: any;
  // timesheet table data filter
  FromDate: any;
  toDate: any;
  format: any;
  userForm: FormGroup;
  user_IdLocal: any;
  userDataforemployee: any;
  fullName: any;
  projectDataTable: boolean = false;
  projectDataForAdmin: boolean = false;
  AdminOnly: boolean = false;
  totalValues: {};
  weekTotal: number = 0;
  grandTotalValue: number;
  totalhours: number;
  employeeId: any;
  numberOfDaysToShow = 7;
  maxEndDate: string;
  employeeTimeSheet: any;
  Hours: number[] = [];
  Minutes: number[] = [];
  selectedHour: any;
  selectedMinute: any;
  Formet: any;
  TimeListFiltered: any;
  EmpoloyeeList: any;
  EmpoloyeeListFiltered: any;
  UserManager: any;
  IdForUpdateStatus: any;
  TimeSheetStatusValue: any;
  TimeSheetAllData: any;
  selectedEmployeeId: any;
  RawTimeSheetData: any;
  AdminEmpoloyeeList: any;
  ExistingTimeSheetId: any;
  TimeSheetList: any = [];
  ExistingTimeSheetId2: any;
  ExistingData: any;
  oldTimeSheetId: any;
  UpdateTimeForm: boolean = true;
  DayHours: number;
  AllDate: any[] = [];
  timeSheetDate: any[] = [];
  timeSheetHours: any[] = [];
  TotalByDate: any[] = [];
  TimeSheetDateKey: { date: any; total: any }[];
  Status: any;
  projectKeyValue: string;
  dateKeyValue: string;
  ByWeek: boolean = true;
  ByDate: boolean = false;
  BySummary: boolean = false;
  employeeid: any;
  startDate: any;
  endDate: any;
  filterDataByDate: any;
  groupedData: any;
  filterDataByWeek: any;
  selectedView: string;
  totalHoursForWeek: number = 0;
  totalSummaryHours: any;
  projectName: any[];
  DateUpdate: boolean;
  dateValuePair: any = {};
  newArray: any[] = [];
  isInputDisabled: boolean = true;
  updatedValue: any[] = [];
  timeSheetComment: string = "";
  activeIndex: number | null = null;
  // created_By: any;
  constructor(
    private fb: FormBuilder,
    private api: TimesheetService,
    private config: Config,
    private datePipe: DatePipe,
    private toaster: Toaster,
    private timeSheetProject: TimeSheetProjectService,
    private toastr: ToastrService,
    private empoloyeeApi: EmployeeService,
    private cdr: ChangeDetectorRef
  ) {
    // timesheet table data filter
    this.FromDate = this.config
      .getMonday(new Date())
      .toISOString()
      .slice(0, 10);

    this.toDate = this.config.getSunday(new Date()).toISOString().slice(0, 10);

    this.userForm = this.fb.group({
      employee_Id: [""],
      from: ["", Validators.required],
      to: ["", Validators.required],
    });

    this.exportForm = this.fb.group({
      format: [""],
    });

    this.entryForm = this.fb.group({
      id: 0,
      projects: "",
      task: "",
      employeeName: ["", Validators.required],
      hours: 0,
      status: "Pending",
      date: [
        this.datePipe.transform(new Date(), "ddMMyy"),
        Validators.required,
      ],
      description: [""],
      dts: [new Date().toISOString().substring(0, 10)],
      employee_Id: 0,
      is_Deleted: false,
      created_By: 0,
    });
  }

  ngOnInit(): void {
    this.fetchProjectNames();
    this.userObj = JSON.parse(localStorage.getItem("userObj"));
    this.userType = this.userObj.userInfo.role_Id;

    this.fullName = this.userObj.userInfo.full_Name;
    this.user_IdLocal = this.userObj.userInfo.user_Id;

    if (this.userType === 2) {
      this.loadDataForEmployee();
    }
    // get table data by filters
    this.GetEmployee();
    this.GetHours();
  }

  formatDatelIST(date: Date): string {
    return this.datePipe.transform(date, "ddMMyy") || "";
  }

  IsManager() {
    if (this.userType === 9) {
      return true;
    } else {
      return false;
    }
  }
  IsEmployee() {
    if (this.userType === 2) {
      return true;
    } else {
      return false;
    }
  }

  IsManagerAndAdmin() {
    if (this.userType === 9 || this.userType === 0 || this.userType === 1) {
      return true;
    } else {
      return false;
    }
  }
  IsManagerAndEmployee() {
    if (this.userType === 9 || this.userType === 2) {
      return true;
    } else {
      return false;
    }
  }
  IsAdmin() {
    if (this.userType === 0 || this.userType === 1) {
      return true;
    } else {
      return false;
    }
  }

  // get projects form form ................................................................
  fetchProjectNames() {
    this.config.startLoader();
    this.timeSheetProject.getAllProjects().subscribe(
      (res: any) => {
        if (res && Array.isArray(res.result)) {
          const projectSet = new Set<string>();
          res.result.forEach((item: any) => {
            projectSet.add(item.project_Name);
          });
          // Convert Set back to an array
          this.projects = Array.from(projectSet);
        } else {
          Swal.fire(
            "API response does not contain expected data:",
            res,
            "error"
          );
        }
        this.config.stopLoader();
      },
      (error) => {
        Swal.fire("Error fetching project names:", error, "error");
        this.config.stopLoader();
      }
    );
  }
  // get projects form form ................................................................

  // Get Employee Id
  updateEmployeeId(event: any) {
    this.selectedEmployeeId = event.target.value;
    console.log("selectedEmployeeId", this.selectedEmployeeId);
  }
  //=========

  // Get From Date
  selectFromDate(val: any) {
    const selectedDate = new Date(val);
    // this.FromDate = val;
    const difference = selectedDate.getDay() - 1;

    const nearestMonday = new Date(selectedDate);
    nearestMonday.setDate(selectedDate.getDate() - difference);

    // Update the FromDate and ToDate variables
    this.FromDate = nearestMonday.toISOString().split("T")[0];

    const endDate = new Date(nearestMonday);

    endDate.setDate(nearestMonday.getDate() + 6);
    this.toDate = endDate.toISOString().split("T")[0];
  }

  //========

  // Get To Date
  selectToDate(val: any) {
    console.log("selectToDate", val);

    this.toDate = val;
  }
  //========

  // Get Selected Formet
  selectFormet(val: any) {
    this.Formet = val.target.value;

    console.log("this.Formet", this.Formet);
    if (this.Formet === "Week") {
      this.ByWeek = true;
      this.ByDate = false;
      this.BySummary = false;
      this.selectedView = "Week";
    } else if (this.Formet === "Date") {
      this.ByWeek = false;
      this.ByDate = true;
      this.BySummary = false;
      this.selectedView = ""; // Clear selectedView when 'By Date' is selected
    } else if (this.Formet === "Summary") {
      this.ByWeek = false;
      this.ByDate = false;
      this.BySummary = true;
      this.selectedView = "";
    }
  }

  // filterTimeStampByDate() {
  //   this.getFilterByDate();
  // }
  //=======

  // Get Employee List

  GetEmployee() {
    if (this.userType === 0 || this.userType === 1) {
      this.api.getalluser().subscribe((res) => {
        this.AdminEmpoloyeeList = res.user;
        console.log("Admin for manager", this.AdminEmpoloyeeList);
      });
    } else {
      this.empoloyeeApi
        .GetmanagerEmployee(this.user_IdLocal)
        .subscribe((res) => {
          this.EmpoloyeeList = res.user;

          console.log("Emplopyee for manager", this.EmpoloyeeList);
        });
    }
  }

  //==============

  // Load Time Sheet Data For admin
  loadDataForAdmin() {
    this.projectDataTable = true;
    this.config.startLoader();
    this.api
      .gettimesheet(this.selectedEmployeeId, this.FromDate, this.toDate)
      .subscribe((res) => {
        this.RawTimeSheetData = res.result;

        console.log("RawTimeSheetData", this.RawTimeSheetData);

        this.Status =
          res.result[0] && res.result[0].Status ? res.result[0].Status : null;

        if (this.RawTimeSheetData) {
          this.calculateHoursByDay();
        }
        this.config.stopLoader();
        if (res.status === "1") {
          this.projectData = {};
          for (const item of res.result) {
            const project = item.Projects;
            if (!this.projectData[project]) {
              this.projectData[project] = {};
            }
            for (const dateKey of Object.keys(item).filter(
              (key) => key !== "Projects"
            )) {
              this.projectData[project][dateKey] = item[dateKey];
            }
          }

          this.grandTotal();
        }
      });
  }

  calculateHoursByDay() {
    let result = {};

    this.RawTimeSheetData.forEach((item) => {
      for (let key in item) {
        if (key !== "Projects" && key !== "Status") {
          if (result[key]) {
            result[key] += item[key];
          } else {
            result[key] = item[key];
          }
        }
      }
    });

    this.TotalByDate = Object.entries(result).map(
      ([date, total]: [string, number]) => ({
        date,
        total: total.toFixed(2),
      })
    );
  }
  //==============

  //  Load Time Sheet Data For Employee
  loadDataForEmployee() {
    this.projectDataTable = true;
    this.config.startLoader();

    console.log("again 255");

    this.api
      .gettimesheet(this.user_IdLocal, this.FromDate, this.toDate)
      .subscribe((res) => {
        console.log("res", res);

        this.RawTimeSheetData = res.result;

        console.log("RawTimeSheetData", this.RawTimeSheetData);

        this.Status = "";
        // res.result[0] && res.result[0].Status ? res.result[0].Status : null;

        this.config.stopLoader();

        if (this.RawTimeSheetData) {
          this.calculateHoursByDay();
        }
        if (res.status === "1") {
          this.projectData = {};
          for (const item of res.result) {
            const project = item.Projects;
            if (!this.projectData[project]) {
              this.projectData[project] = {};
            }
            for (const dateKey of Object.keys(item).filter(
              (key) => key !== "Projects"
            )) {
              this.projectData[project][dateKey] = item[dateKey];
            }
          }
          this.grandTotal();
        }
      });
  }
  //==============

  // Open Modal To Save Data
  openmodel() {
    this.ModalOpen = true;
  }
  //======

  // Get Hours  Value
  GetSelectHours(event: any) {
    this.selectedHour = event.target.value;
  }
  //=======

  // Reset Hours for Employee
  ResetHours(projectKey: string, dateKey: string) {
    this.TimeSheetDateKey = Object.entries(dateKey).map(([date, total]) => {
      return {
        date,
        total,
      };
    });

    const dateValue = this.TimeSheetDateKey.map((entry) => entry.date);
    const dateValues = dateValue.slice(1);
    const resetObject = {
      DateList: dateValues,
      Project: projectKey,
      UserId: this.user_IdLocal,
    };

    if (resetObject) {
      this.config.startLoader();

      this.api.ResetHours(resetObject).subscribe((res) => {
        this.config.stopLoader();

        if (res.status === "1") {
          this.loadDataForEmployee();
        }
      });
    }
  }
  //=========

  // Reset Hours for Employee
  ResetHoursForDay(
    projectKey: string | { value: { projects: { project_name: string }[] } },
    dateKey: { date: string }
  ) {
    console.log("projectKey", projectKey);
    console.log("dateKey", dateKey);
    const projectNames =
      typeof projectKey === "object" && "value" in projectKey
        ? projectKey.value.projects.map((project) => project.project_name)
        : [projectKey];

    this.projectName = projectNames;
    const dateValue = dateKey.date;

    const resetObject = {
      DateList: dateValue,
      Project: this.projectName,
      UserId: parseInt(this.selectedEmployeeId) || parseInt(this.user_IdLocal),
    };

    console.log("resetObject", resetObject);

    if (resetObject) {
      this.config.startLoader();

      this.api.ResetHoursForDate(resetObject).subscribe((res) => {
        this.config.stopLoader();

        if (res.status === "1") {
          this.getFilterByDate();
        }
      });
    }
  }
  //=========

  SubmitHoursForDate(
    projectKey: string | { value: { projects: { project_name: string }[] } },
    dateKey: { date: string }
  ) {
    const projectNames =
      typeof projectKey === "object" && "value" in projectKey
        ? projectKey.value.projects.map((project) => project.project_name)
        : [projectKey];

    this.projectName = projectNames;
    const dateValue = dateKey.date;

    const resetObject = {
      DateList: dateValue,
      Project: this.projectName,
      UserId: parseInt(this.selectedEmployeeId) || parseInt(this.user_IdLocal),
    };

    console.log("resetObject", resetObject);

    if (resetObject) {
      this.config.startLoader();

      this.api
        .SubmitTimeSheetStatus(resetObject, "Submitted")
        .subscribe((res) => {
          this.config.stopLoader();

          if (res.status === "1") {
            this.getFilterByDate();
          }
        });
    }
  }

  //Submit TimeSheet for Employee
  SubmitTimeSheet(projectKey: string, dateKey: string) {
    this.TimeSheetDateKey = Object.entries(dateKey).map(([date, total]) => {
      return {
        date,
        total,
      };
    });

    const allTotal = this.TimeSheetDateKey.map((entry) => entry.total);

    const allActualValue = allTotal.filter((value, index) => index !== 0);

    const allTotalGreaterThanZero = allActualValue.every(
      (value) => value !== null
    );

    if (!allTotalGreaterThanZero) {
      Swal.fire(
        "Status",
        "Please make sure that values are assigned to all weekdays.",
        "error"
      );
      return;
    }

    const dateValue = this.TimeSheetDateKey.map((entry) => entry.date);
    const dateValues = dateValue.slice(1);
    const resetObject = {
      DateList: dateValues,
      Project: projectKey,
      UserId: this.user_IdLocal,
    };

    console.log("resetObject", resetObject);

    if (resetObject) {
      this.config.startLoader();
      this.api
        .SubmitTimeSheetStatusForWeek(resetObject, "Submitted", "TimeSheet")
        .subscribe((res) => {
          console.log("res time sheet", res);

          this.config.stopLoader();

          if (res.status === "1") {
            this.isInputDisabled = true;
            this.config.ToastrSuccess("Submit Succesfully");
            this.loadDataForEmployee();
          }
        });
    }
  }

  //=========
  // Get  Mintues  Value
  GetSelectMinutes(event: any) {
    this.selectedMinute = event.target.value;
  }
  // ========

  // Convert Value In Decimal
  convertTimeToHours(decimalHours: number) {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    const formattedTime = `${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}`;
    this.entryForm.get("hours").setValue(formattedTime);
  }
  // ========

  // for convert time to hours
  timeToDecimal(timeValue: string): number {
    const [hours, minutes] = timeValue.split(":").map(Number);
    const decimalHours = hours + minutes;
    return decimalHours;
  }
  // ========

  // Get Hours Value in deciamal
  GetHours() {
    this.Hours = [];
    this.Minutes = [];
    const theHH = 24;
    const theMM = 60;
    for (let i = 0; i < theHH; i++) {
      this.Hours.push(i);
    }
    for (let i = 0; i < theMM; i++) {
      this.Minutes.push(i);
    }
  }
  //=========

  // Set Multiple List of TimeSheet
  addTimeSheetList() {
    this.UpdateTimeForm = true;
    const formValue = this.entryForm.value;

    if (formValue.employee_Id === 0 || formValue.employee_Id === null) {
      formValue.employee_Id = this.user_IdLocal;
      formValue.created_By = this.user_IdLocal;
    }
    if (formValue.Status === null || typeof formValue.Status === "undefined") {
      formValue.Status = "Pending";
    }
    if (!formValue.projects) {
      this.config.ToastrError("Please select a valid Projects");
      return;
    }

    if (!formValue.task) {
      this.config.ToastrError("Please select a valid Task");
      return;
    }

    if (!formValue.date) {
      this.config.ToastrError("Please select a valid Date");
      return;
    }

    if (
      !(this.entryForm.value.hours = parseFloat(
        `${this.selectedHour}.${this.selectedMinute}`
      ))
    ) {
      this.config.ToastrError("Please select a valid Hours value");
      return;
    }

    this.TimeSheetList.push(formValue);

    // Reset the form
    this.entryForm.reset({
      id: 0,
      projects: "",
      task: "",
      employeeName: "",
      hours: 0,
      status: "Pending",
      date: this.datePipe.transform(new Date(), "ddMMyy"),
      description: "",
      dts: new Date().toISOString().substring(0, 10),
      employee_Id: this.user_IdLocal,
      is_Deleted: false,
      created_By: this.user_IdLocal,
    });
    this.selectedHour = 0;
    this.selectedMinute = 0;
  }
  //========

  // Save TimeSheet
  submitForm() {
    this.config.startLoader();
    if (this.TimeSheetList.length > 0) {
      let timeSheetsRequest = { Time_SheetsRequest: this.TimeSheetList };

      console.log("timeSheetsRequest", timeSheetsRequest);

      this.api.saveMultitimesheet(timeSheetsRequest).subscribe(
        (response) => {
          this.config.stopLoader();
          if (response.status === "1") {
            this.ModalOpen = false;
            this.isInputDisabled = true;
            Swal.fire("Status", response.message, "success");
            this.entryForm.reset();
            this.TimeSheetList = [];
            this.loadDataForEmployee();
          } else {
            Swal.fire("Status", response.message, "error");
          }
        },
        (error) => {
          Swal.fire("Status", `API call error: ${error}`, "error");
        }
      );
    }
  }
  //========

  // Chnage input
  updateObject(date, project, hours) {
    let newObject: any = {
      id: 0,
      projects: project,
      task: "",
      employeeName: this.fullName,
      hours: parseFloat(hours),
      status: "Pending",
      date: date,
      description: "",
      dts: new Date().toISOString().substring(0, 10),
      employee_Id:
        this.userType === 0 || this.userType === 1
          ? parseInt(this.selectedEmployeeId)
          : parseInt(this.user_IdLocal),
      is_Deleted: false,
      created_By:
        this.userType === 0 || this.userType === 1
          ? parseInt(this.selectedEmployeeId)
          : parseInt(this.user_IdLocal),
    };

    const existingObjectIndex = this.updatedValue.findIndex(
      (obj) => obj.date === date
    );

    if (existingObjectIndex !== -1) {
      this.updatedValue[existingObjectIndex] = newObject;
    } else {
      this.updatedValue.push(newObject);
    }
  }

  // toggleInputState() {
  //   this.isInputDisabled = !this.isInputDisabled;
  // }

  toggleInputState(index: number) {
    if (this.activeIndex === index) {
      this.activeIndex = null; // Disable if the same index is clicked again
    } else {
      this.activeIndex = index; // Set the new active index
    }
  }

  onTdClick(
    projectKey: string,
    dateKey: string,
    dateValuePair: string,
    status: string
  ) {
    this.DayHours = parseInt(dateValuePair);

    if (projectKey && dateKey && this.user_IdLocal && this.DayHours > 0) {
      if (
        (this.userType === 2 && status === "Pending") ||
        status === "Rejected"
      ) {
        this.ModalOpen = true;
        this.UpdateTimeForm = false;

        this.config.startLoader();
        this.api
          .GetByprojectsAndDate(this.user_IdLocal, projectKey, dateKey)
          .subscribe((res) => {
            this.config.stopLoader();
            if (res.status === "1") {
              this.oldTimeSheetId = res.result.id || 0;
              const hoursString = res.result.hours.toString();
              const [integerPart, decimalPart] = hoursString.split(".");
              this.selectedHour = parseInt(integerPart);
              this.selectedMinute = parseInt(decimalPart);

              this.entryForm.patchValue({
                id: res.result.id || 0,
                projects: res.result.projects,
                task: res.result.task,
                employeeName: res.result.employeeName,
                status: res.result.status,
                date: moment(res.result.date).format("YYYY-MM-DD"),
                description: res.result.description,
                dts: res.result.dts,
                employee_Id: res.result.employee_Id,
                is_Deleted: false,
              });
            }
          });
      }
    } else {
      this.ModalOpen = true;
      this.UpdateTimeForm = false;
      this.entryForm.patchValue({
        id: 0,
        employee_Id: this.user_IdLocal,
        status: "Pending",
        date: moment(dateKey).format("YYYY-MM-DD"),
        is_Deleted: false,
      });
      this.selectedHour = 0;
      this.selectedMinute = 0;
    }
  }

  // ========

  // Update TimeSheet

  UpdateForm2(index: number) {
    console.log("this.updatedValue", this.updatedValue);
    this.activeIndex = null;
    let timeSheetsRequest = { Time_SheetsRequest: this.updatedValue };
    this.config.startLoader();
    this.api.saveMultitimesheet(timeSheetsRequest).subscribe(
      (response) => {
        this.config.stopLoader();

        console.log("res", response);
        if (response.status === "1") {
          this.ModalOpen = false;
          Swal.fire("Status", response.message, "success");
          this.entryForm.reset();
          // this.loadDataForEmployee();
          this.calculateHoursByDay();
          this.isInputDisabled = true;
          this.TimeSheetList = [];
          this.updatedValue = [];
          this.UpdateTimeForm = true;
        } else {
          Swal.fire("Status", response.message, "error");
        }
      },
      (error) => {
        Swal.fire("Status", `API call error: ${error}`, "error");
      }
    );
  }
  UpdateForm() {
    this.UpdateTimeForm = false;
    this.config.startLoader();
    this.entryForm.value.hours = parseFloat(
      `${this.selectedHour}.${this.selectedMinute}`
    );
    this.entryForm.value.created_By = this.user_IdLocal;
    this.entryForm.value.employee_Id = this.user_IdLocal;
    this.entryForm.value.employeeName = this.fullName;

    this.api.savetimesheet(this.entryForm.value).subscribe(
      (response) => {
        this.config.stopLoader();
        if (response.status === "1") {
          this.ModalOpen = false;
          Swal.fire("Status", response.message, "success");
          this.entryForm.reset();
          this.isInputDisabled = true;
          this.loadDataForEmployee();
          this.TimeSheetList = [];
          this.UpdateTimeForm = true;
        } else {
          Swal.fire("Status", response.message, "error");
        }
      },
      (error) => {
        Swal.fire("Status", `API call error: ${error}`, "error");
      }
    );
  }
  //========

  // Get Total of Hours
  grandTotal() {
    this.grandTotalValue = 0;
    for (let project of Object.values(this.projectData)) {
      this.grandTotalValue += this.calculateTotal(project);
    }
    this.totalhours = parseFloat(this.grandTotalValue.toFixed(2));
    return this.totalhours;
  }
  //========

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  // Get Total Week Hours
  calculateTotal(dateValues: any): number {
    let total = 0;
    for (const dateKey of Object.keys(dateValues)) {
      if (dateKey.toLowerCase() === "id") {
        continue;
      }
      const value = dateValues[dateKey];
      total += parseFloat(value) || 0;
    }
    this.weekTotal = parseFloat(total.toFixed(2));
    return this.weekTotal;
  }
  //========

  // Export Data

  exportWeekData() {
    if (this.selectedEmployeeId == 0 || this.selectedEmployeeId === null) {
      this.toastr.error("Please Select employeee", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (this.user_Id === 0 || this.user_Id === null) {
      this.toastr.error("Please Select Employee", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }

    let empId = 0;

    if (this.userType === 0 || this.userType === 1) {
      empId = this.selectedEmployeeId;
    } else {
      empId = this.user_IdLocal;
    }

    const downloadURL = `${this.config.APIUrl}QRT_Time_Sheet/ExportTimeSheetByDates?StartDate=${this.FromDate}&End_Date=${this.toDate}&Employee_Id=${empId}`;
    window.location.href = downloadURL;
  }

  exportData() {
    if (this.Formet === "" || this.Formet === null) {
      this.toastr.error("Please Select Format", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }
    if (this.user_Id === 0 || this.user_Id === null) {
      this.toastr.error("Please Select Employee", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }

    const downloadURL = `${this.config.APIUrl}QRT_Time_Sheet/ExportTimesheet?Login_Key=debug1&employee_Id=${this.selectedEmployeeId}&StartDate=${this.FromDate}&EndDate=${this.toDate}&Format=${this.Formet}`;
    window.location.href = downloadURL;
  }

  removeTimesheetSingleData(timeSheet: any) {
    this.TimeSheetList = this.TimeSheetList.filter(
      (item: any) => item !== timeSheet
    );
  }

  Delete(Id) {
    Swal.fire({
      title: "Are you sure want to delete?",
      // icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.config.startLoader();
        this.api.DeleteById(Id).subscribe((res) => {
          if (res.status === "1") {
            this.toaster.open({
              text: res.message,
              position: "top-right",
              type: "danger",
            });
            this.config.stopLoader();
          } else {
            this.toaster.open({
              text: res.message,
              position: "top-right",
              type: "danger",
            });
          }
        });
      }
    });
  }

  // Close the modal
  cancel() {
    this.ModalOpen = false;
    this.UpdateTimeForm = true;
    this.TimeSheetList = [];
    this.entryForm.reset();
  }

  // get Status value
  TimeSheetStatus(val: any) {
    this.TimeSheetStatusValue = val;
  }
  //======

  openModal2(projectKey: string, dateKey: string) {
    this.ModalOpen2 = true;
    this.projectKeyValue = projectKey;
    this.dateKeyValue = dateKey;
  }

  cancel2() {
    this.ModalOpen2 = true;
  }

  ChangeStatus() {
    if (this.projectKeyValue && this.dateKeyValue) {
      this.TimeSheetDateKey = Object.entries(this.dateKeyValue).map(
        ([date, total]) => {
          return {
            date,
            total,
          };
        }
      );

      const dateValue = this.TimeSheetDateKey.map((entry) => entry.date);
      const dateValues = dateValue.slice(1);
      const resetObject = {
        DateList: dateValues,
        Project: this.projectKeyValue,
        UserId: this.selectedEmployeeId,
      };

      if (resetObject) {
        this.config.startLoader();
        this.api
          .SubmitTimeSheetStatus(resetObject, this.TimeSheetStatusValue)
          .subscribe((res) => {
            if (res.status === "1") {
              this.config.stopLoader();
              this.ModalOpen2 = false;
              this.loadDataForAdmin();
            }
          });
      }
    }
  }

  ChangeStatusWeek() {
    if (
      this.TimeSheetStatusValue == "" ||
      this.TimeSheetStatusValue == null ||
      this.TimeSheetStatusValue == undefined
    ) {
      this.toastr.error("Please Select Status", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });

      return;
    }
    const comment = this.timeSheetComment || "TimeSheet";
    if (this.projectKeyValue && this.dateKeyValue) {
      this.TimeSheetDateKey = Object.entries(this.dateKeyValue).map(
        ([date, total]) => {
          return {
            date,
            total,
          };
        }
      );

      const dateValue = this.TimeSheetDateKey.map((entry) => entry.date);
      const dateValues = dateValue.slice(1);
      const resetObject = {
        DateList: dateValues,
        Project: this.projectKeyValue,
        UserId: this.selectedEmployeeId,
      };

      console.log("resetObject", resetObject);
      console.log("TimeSheetDateKey", this.TimeSheetDateKey);

      if (resetObject) {
        this.config.startLoader();
        this.api
          .SubmitTimeSheetStatusForWeek(
            resetObject,
            this.TimeSheetStatusValue,
            comment
          )
          .subscribe((res) => {
            if (res.status === "1") {
              this.config.stopLoader();
              this.ModalOpen2 = false;
              this.loadDataForAdmin();
            }
          });
      }
    }
  }

  // filter by date section start

  getFilterByDate() {
    this.config.startLoader();
    this.api
      .getTimeSheetByDate(
        this.selectedEmployeeId || this.user_IdLocal,
        this.FromDate,
        this.toDate
      )
      .subscribe(
        (res) => {
          this.config.stopLoader();
          this.filterDataByDate = res.result;

          // Group and merge data by date
          this.groupedData = this.filterDataByDate.reduce((acc, curr) => {
            const dateKey = curr.workDate.split("T")[0];
            if (!acc[dateKey]) {
              acc[dateKey] = {
                date: dateKey,
                projects: [
                  {
                    project_name: curr.projectName,
                    project_hours: curr.totalHours,
                    employee_Name: curr.employee_Name,
                    status: curr.status,
                  },
                ],
              };
            } else {
              acc[dateKey].projects.push({
                project_name: curr.projectName,
                project_hours: curr.totalHours,
                employee_Name: curr.employee_Name,
                status: curr.status,
              });
            }
            return acc;
          }, {});

          // Calculate total hours for each group
          this.calculateTotalHours();
        },
        (error) => {
          this.config.stopLoader();
          console.error("Error fetching data:", error);
        }
      );
  }

  exportDataDateWise() {
    if (this.selectedEmployeeId == 0 || this.selectedEmployeeId === null) {
      this.toastr.error("Please Select employee", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }

    if (
      this.FromDate == "" ||
      this.FromDate === null ||
      this.toDate == "" ||
      this.toDate === null
    ) {
      this.toastr.error("Please Select valid date", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }

    let empId = 0;

    if (this.userType === 0 || this.userType === 1) {
      empId = this.selectedEmployeeId;
    } else {
      empId = this.user_IdLocal;
    }

    const downloadURL = `${this.config.APIUrl}Time_Sheet_Projects/ExportTimeSheetData?Login_Key=debug1&Employee_Id=${empId}&StartDate=${this.FromDate}&EndDate=${this.toDate}`;
    window.location.href = downloadURL;
  }

  // Function to calculate total hours for each group
  totalHours: number = 0;

  calculateTotalHours() {
    this.totalHours = 0;
    for (const dateKey of Object.keys(this.groupedData)) {
      let groupTotalHours = 0;
      this.groupedData[dateKey].projects.forEach((project) => {
        groupTotalHours += project.project_hours;
      });
      this.groupedData[dateKey].total_hours = groupTotalHours;
      this.totalHours += groupTotalHours;
    }

    this.totalHours = parseFloat(this.totalHours.toFixed(2));
  }

  getFilterByWeek() {
    this.config.startLoader();

    this.api
      .getTimeSheetSummaryByWeek(
        this.selectedEmployeeId || this.user_IdLocal,
        this.FromDate,
        this.toDate
      )
      .subscribe(
        (res) => {
          this.filterDataByWeek = res.result;
          console.log("filterDataByWeek", this.filterDataByWeek);

          if (this.filterDataByWeek) {
            this.calculateTotalHoursForSummery();
          }
        },
        (error) => {
          console.error("Error fetching data:", error);
        },
        () => {
          this.config.stopLoader();
        }
      );
  }

  exportDataSummary() {
    if (this.selectedEmployeeId == 0 || this.selectedEmployeeId === null) {
      this.toastr.error("Please Select employee", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }

    if (
      this.FromDate == "" ||
      this.FromDate === null ||
      this.toDate == "" ||
      this.toDate === null
    ) {
      this.toastr.error("Please Select valid date", "", {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        positionClass: "toast-top-right",
        toastClass: "alert alert-error alert-with-icon",
      });
      return;
    }

    let empId = 0;

    if (this.userType === 0 || this.userType === 1) {
      empId = this.selectedEmployeeId;
    } else {
      empId = this.user_IdLocal;
    }

    const downloadURL = `${this.config.APIUrl}Time_Sheet_Projects/ExportTimeSheetSummaryByWeek?Login_Key=debug1&Employee_Id=${empId}&StartDate=${this.FromDate}&EndDate=${this.toDate}`;
    window.location.href = downloadURL;
  }

  calculateTotalHoursForSummery() {
    this.totalSummaryHours = 0; // Initialize to 0
    this.filterDataByWeek.forEach((data) => {
      this.totalSummaryHours += data.totalHours;
    });
  }

  getStatusBackgroundColor(status: string): string {
    switch (status) {
      case "Pending":
        return "rgba(255, 193, 7, 0.2)"; // dark yellow
      case "Approved":
        return "rgba(92, 184, 92, 0.2)"; // light green
      case "Rejected":
        return "rgba(217, 83, 79, 0.2)"; // light red
      default:
        return "";
    }
  }

  checkDataExists(): boolean {
    return (
      this.filterDataByWeek &&
      this.filterDataByWeek.length > 0 &&
      this.filterDataByWeek.some((item) => item.totalHours > 0)
    );
  }
  // checkDataExists(): boolean {
  //   return (
  //     this.filterDataByDate &&
  //     this.filterDataByDate.length > 0 &&
  //     this.filterDataByDate.some((item)=> item.)
  //   )
  // }
}

// ..........................................................................get table data by filters-end,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,
